export default Object.freeze({
  EDIT_SETTINGS: 30_011
});
